import React from "react";
import Slider from "react-slick";
import TestItem from "./TestItem";

import "../../../assets/slick/slick.min.css";
import "../../../assets/slick/slick-theme.min.css";

class TestItemsSlider extends React.PureComponent {
  render() {
    const slickSettings = {
      className: "slider variable-width",
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true
    };
    const { items } = this.props;

    return (
      <Slider {...slickSettings}>
        {Array.isArray(items) &&
          items.map(test => (
            <div style={{ width: 240, paddingRight: 15 }}>
              <TestItem test={test} />
            </div>
          ))}
        {/*<div style={{ width: 240 }}>*/}
        {/*  <TestItem title="Test para pieles sensibles." />*/}
        {/*</div>*/}
        {/*<div style={{ width: 240 }}>*/}
        {/*  <TestItem title="Test para pieles sensibles." />*/}
        {/*</div>*/}
        {/*<div style={{ width: 240 }}>*/}
        {/*  <TestItem title="Test para pieles sensibles." />*/}
        {/*</div>*/}
      </Slider>
    );
  }
}

export default TestItemsSlider;



// WEBPACK FOOTER //
// ./src/modules/test/components/TestItemsSlider.js